import { requiredAnnualLumpsumForTarget } from "../../engine/calculations";

const config = {
  key: "req-annual-lumpsum",
  title: "Annual Lumpsum Required For Target FV",
  category: "Target-Based",
  description: "Work out the fixed amount you need to invest once a year to reach a future value target.",
  fields: [
    { key: "targetFV", label: "Target future value", type: "currency", default: 50_00_000, min: 1000, max: 100_00_00_000 },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
    { key: "years", label: "Years to target", type: "number", default: 10, min: 1, max: 40 },
  ],
  chart: {
    type: "bar",
    xKey: "name",
    series: [{ key: "amount", label: "Amount", colorVar: "--gold" }],
  },
  compute(values) {
    const targetFV = Number(values.targetFV) || 0;
    const annualRate = (Number(values.returnRate) || 0) / 100;
    const years = Number(values.years) || 0;

    const requiredAnnual = requiredAnnualLumpsumForTarget(targetFV, annualRate, years);
    const totalInvested = requiredAnnual * years;

    return {
      headline: { label: "Required annual investment", value: requiredAnnual },
      breakdown: [
        { label: "Target future value", value: targetFV },
        { label: "Total invested over the period", value: totalInvested },
        { label: "Estimated gains", value: targetFV - totalInvested },
      ],
      series: [
        { name: "Total Invested", amount: totalInvested },
        { name: "Target FV", amount: targetFV },
      ],
    };
  },
};

export default config;
